import { gviTheme } from '@smartshoppers/gvi/theme'

// GVI and GVIFE are supposed to be always the same
export const gvifeTheme = gviTheme
